export var JoveFormTitleDirectionEnum;

(function (JoveFormTitleDirectionEnum) {
  JoveFormTitleDirectionEnum["top"] = "top";
  JoveFormTitleDirectionEnum["left"] = "left";
})(JoveFormTitleDirectionEnum || (JoveFormTitleDirectionEnum = {}));